// Orders chart vs list blocks for battlefield vs desktop dashboard layout.
import { Box } from '@mui/material';

export function DashboardMainColumn({
  isBattlefield,
  chartSection,
  listSection,
  panelGap,
}) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: isBattlefield ? 2 : panelGap,
      }}
    >
      {isBattlefield ? (
        <>
          {listSection}
          {chartSection}
        </>
      ) : (
        <>
          {chartSection}
          {listSection}
        </>
      )}
    </Box>
  );
}
